import React from "react"
import { Box, Button, Container, Heading } from "@chakra-ui/react"

import TileCarousel from "@components/TileCarousel/TileCarousel"
import Link from "@components/Link"
import { useRoutes } from "@hooks/useRoutes"
import { useArticles } from "@hooks/useArticles"
import LearnPageItem from "@components/LearnPageItem"
import { SectionProps, withSection } from "@app/hoc/Section"
import { LearnPageItemProps } from "@components/LearnPageItem/LearnPageItem"

export interface LearnPageCarouselProps extends SectionProps {
  title: string
  link?: GatsbyTypes.SanityInternal
  articles: GatsbyTypes.SanityArticle[]
  category?: GatsbyTypes.SanityArticleCategory
  theme?: "Dark" | "Light"
  carouselSettings?: GatsbyTypes.SanityCarouselSettings
}

export interface FeaturedArticlesItemProps {
  item: NormalisedArticle
  handleTrackingClick: VoidFunction
}

const LearnPageCarousel = ({
  title,
  link,
  category,
  articles: featured,
  theme,
  carouselSettings,
  innerRef,
  handleTrackingClick,
}: LearnPageCarouselProps) => {
  const { urlResolver } = useRoutes()
  const { getArticles, normaliseArticles } = useArticles()

  const resolvedLink = urlResolver(link)
  const articles = category?.handle?.current ? getArticles(category?.handle?.current) : featured?.length ? featured : []
  const items = normaliseArticles(articles)

  return (
    <Box bg={theme === "Dark" ? "brand.beige.dark" : "white"} my={2} ref={innerRef} ml={["0px", "-64px"]}>
      <Container py={5} textAlign="center">
        <Heading as="h2" size="h2" mb={3}>
          {title}
        </Heading>
        {items.length > 0 && (
          <TileCarousel carouselSettings={carouselSettings} spaceBetweenTiles={16}>
            {items.map(page => {
              const props: LearnPageItemProps = { page, handleTrackingClick }

              return (
                <Box mb={3.5} key={page.key} w="316px">
                  <LearnPageItem {...props} />
                </Box>
              )
            })}
          </TileCarousel>
        )}
        <Button as={Link} to={resolvedLink.url} variant="blue" mt={2.5}>
          {resolvedLink.title}
        </Button>
      </Container>
    </Box>
  )
}

export default React.memo(withSection(LearnPageCarousel))
